import { render, staticRenderFns } from "./DragnDrop.vue?vue&type=template&id=5c0fec8c&scoped=true&"
import script from "./DragnDrop.vue?vue&type=script&lang=js&"
export * from "./DragnDrop.vue?vue&type=script&lang=js&"
import style0 from "./DragnDrop.vue?vue&type=style&index=0&id=5c0fec8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0fec8c",
  null
  
)

export default component.exports